<footer class="footer">
    <div class="footer-row row">
        <div class="footer-widget col-sm-4">
            <h3>{{'site_footer.contact.title'|translate}}</h3>
            <p>info&#64;projectseagrass.org</p>
            <p>Project Seagrass<br />
                Unit 1, Garth Drive<br />
                Brackla Industrial Estate<br />
                Bridgend<br />
                United Kingdom<br />
                CF31 2AQ</p>
        </div>
        <div class="footer-widget col-sm-4">
            <h3>{{'site_footer.ps.title'|translate}}</h3>
            <p [innerHTML]="'site_footer.ps.copyright'|translate"></p>
            <p [innerHTML]="'site_footer.ps.charity'|translate"></p>
            <p><a routerLink="/terms">{{'site_footer.ps.terms'|translate}}</a></p>
        </div>
       
        <div class="footer-widget footer-socials col-sm-4">
            <h3>{{'site_footer.social.title'|translate}}</h3>
            <a class="social-button-facebook" href="https://www.facebook.com/ProjectSeagrass" target="_blank"><fa-icon
                    [icon]="faFacebookSquare"></fa-icon></a>
            <a class="social-button-twitter" href="https://twitter.com/projectseagrass" target="_blank"><fa-icon
                    [icon]="faTwitterSquare"></fa-icon></a>
            <a class="social-button-linkedin" href="https://www.linkedin.com/company/project-seagrass"
                target="_blank"><fa-icon [icon]="faLinkedin"></fa-icon></a>
            <a class="social-button-youtube" href="https://www.youtube.com/channel/UCGSHPlN3rgaE04a0bgzCYjw/featured"
                target="_blank"><fa-icon [icon]="faYoutubeSquare"></fa-icon></a>
            <a class="social-button-instagram" href="https://www.instagram.com/projectseagrass/"
                target="_blank"><fa-icon [icon]="faInstagramSquare"></fa-icon></a>
        </div>
    </div>

   
</footer>